module.exports = __webpack_public_path__ + "img/news.fb5e0391.jpg";